module.exports = __webpack_public_path__ + "img/compare-the-market.91365ace.svg";